import { FileType } from './file-type.enum';
import { Author } from './author';
import { FileStatus } from './file-status.enum';
import { Source } from './source.enum';

export class File implements IFile {
  id: string;
  parentId: string;
  name: string;
  displayName: string;
  contentType: FileType;
  createdTime: number;
  updateDate: number;
  source: Source;
  documentId: string;
  contentId: string;
  containerId?:string;//keep reference of the container (e.g Storyboard, topic id) used forr sending email
  size?: number;
  description?: string;
  src?: string;
  status?: FileStatus;
  author?: Author;
  coverPage?: boolean;
  fileUrl: string;

  constructor(
    id: string,
    parentId: string,
    name: string,
    displayName: string,
    contentType: FileType,
    createdTime: number,
    updateDate: number,
    source: Source,
    documentId: string,
    fileUrl?: string,
    contentId?: string,
    size?: number,
    description?: string,
    src?: string,
    status?: FileStatus,
    author?: Author,
    coverPage?: boolean
  ) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.displayName = displayName;
    this.contentType = contentType;
    this.createdTime = createdTime;
    this.updateDate = updateDate;
    this.source = source;
    this.documentId = documentId;
    this.contentId = contentId;
    this.size = size;
    this.description = description;
    this.src = src;
    this.status = status;
    this.author = author;
    this.coverPage = coverPage;
    this.fileUrl = fileUrl;
  }
}
export interface IFile {
  id: string;
  source:string;
  createdTime:number;
  name:string;
  displayName:string;
  contentType?:string;
  containerId?:string;//keep reference of the container (e.g Storyboard, topic id) used forr sending email
  fileUrl?: string;
  contentId:string;
}



// WEBPACK FOOTER //
// ./src/app/models/file.ts